var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#813BF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0003 6.83325C14.7239 6.83325 16.358 7.43123 17.7808 8.5383C19.2036 9.63729 20.415 11.2454 21.2849 13.2575C21.3499 13.411 21.3499 13.5888 21.2849 13.7343C19.545 17.7585 16.4475 20.1666 13.0003 20.1666H12.9922C9.55317 20.1666 6.45561 17.7585 4.71577 13.7343C4.65073 13.5888 4.65073 13.411 4.71577 13.2575C6.45561 9.23325 9.55317 6.83325 12.9922 6.83325H13.0003ZM13.0003 10.2676C11.2036 10.2676 9.74829 11.7141 9.74829 13.4999C9.74829 15.2777 11.2036 16.7242 13.0003 16.7242C14.7889 16.7242 16.2442 15.2777 16.2442 13.4999C16.2442 11.7141 14.7889 10.2676 13.0003 10.2676ZM13.0013 11.4779C14.1151 11.4779 15.0257 12.383 15.0257 13.4981C15.0257 14.6052 14.1151 15.5103 13.0013 15.5103C11.8794 15.5103 10.9688 14.6052 10.9688 13.4981C10.9688 13.3608 10.985 13.2315 11.0094 13.1022H11.0501C11.9525 13.1022 12.6842 12.3911 12.7167 11.5022C12.8062 11.486 12.9037 11.4779 13.0013 11.4779Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.a3e545c1563694609626c1a1e4b7bfb3.svg";
export { ForwardRef as ReactComponent };